import {React, StyledProps, styled} from '@api'
import {Spinner} from '@blueprintjs/core'
import classNames from 'classnames'
import * as css from './LoadingIndicator.css'

const Text = styled.span`
  margin-top: var(--theme-spacing);
  font:var(--typography-headline);
  color:var(--typography-headline-color);
`

interface MyProps extends StyledProps {
  size?: number
  text?: string | JSX.Element
  type?: 'circle' | 'placeholder'
}
export class LoadingIndicator extends React.Component<MyProps> {
  static defaultProps = {
    type: 'circle',
    size: 40
  }

  render() {
    const {props: {type, className, size, text, ...props}} = this;

    return <div className={classNames(css.root, className, 'animate__animated animate__fadeIn')} data-type='LoadingIndicator' data-loading-type={type} {...props}>
      {type == 'circle' ? /*<CircularProgress color={'secondary'} size={size}/>*/
       <Spinner size={size} />
      : type === 'placeholder' ? <span className={css.placeholder} />
      : null}
      {text && <Text>{text}</Text>}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/LoadingIndicator.tsx